import React from 'react';
import PropTypes from 'prop-types';
import 'src/styles/sidebar.css';

function Sidebar (props) {
	return (<>
		<div id="uglib-sidebar" className="col-md-3">
			{props.children}
		</div>
	</>)
	
}

Sidebar.propTypes = {
	children: PropTypes.node.isRequired,
}


export default Sidebar